import { useContext } from 'react';
import { PermissionContext } from 'contexts/PermissionProviderContext';

export function usePermissions() {
  const context = useContext(PermissionContext);

  if (!context) {
    throw new Error('usePermissions must be used within a PermissionProvider');
  }

  return context;
}
